import React, { FC } from 'react'

import styles from '../Story.module.scss'
import { cn } from '../../../shared/utils'
import { useStoryContext } from '../StoryContext'
import { IconName } from '@fortawesome/fontawesome-common-types'
import { Icon } from '@wmgtech/legato'
import { userFullName } from '../../../shared/utils/userFullName'
import { formatDate } from '../../../shared/utils/formatDate'

type TStoryMetaProps = {}

export const StoryMeta: FC<TStoryMetaProps> = (props) => {
  const story = useStoryContext()
  const isUpdated = story.updated_at !== story.created_at && story.lastEditor !== null
  return (
    <div className={cn(styles.meta)}>
      {isUpdated && story.lastEditor ? (
        <MetaRow
          icon="pen"
          dateTime={formatDate({ date: story.updated_at })}
          authorFullName={userFullName(story.lastEditor)}
          authorEmail={story.lastEditor.email}
        />
      ) : null}
      {story.author ? (
        <MetaRow
          icon="archive"
          dateTime={formatDate({ date: story.created_at })}
          authorFullName={userFullName(story.author)}
          authorEmail={story.author.email}
        />
      ) : null}
      {story.pinned && story.pinned_at && story.pinned_by ? (
        <MetaRow
          icon="thumbtack"
          dateTime={formatDate({ date: story.pinned_at })}
          authorFullName={story.pinned_by}
          iconClassName={styles.pinnedIcon}
        />
      ) : null}
    </div>
  )
}

type TMetaRowProps = {
  icon: IconName
  dateTime: string
  authorFullName: string
  authorEmail?: string
  iconClassName?: string
}
const MetaRow: FC<TMetaRowProps> = (props) => {
  const {
    authorFullName: name,
    authorEmail: email,
    dateTime,
    icon
  } = props
  const renderAuthor = () => {
    const authorTag = email
      ? (<a href={`mailto:${email}`} className={styles.emailLink}>{name}</a>)
      : name

    return <>by {authorTag}</>
  }

  return (
    <div className={cn(styles.metaRow)}>
      <Icon name={icon} className={cn(props.iconClassName)} />
      <span>{dateTime} {renderAuthor()}</span>
    </div>
  )
}


